module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_1.f74c037b.pdf";